export class UserService {
    constructor(apiService) {
      this.apiService = apiService;
    }
  
    getUsers(options) {
      return this.apiService.get('/users', options);
    }

    createUser(data) {
      return this.apiService.post('/users', data);
    }

    updateUser(id, data) {
      return this.apiService.put(`/users/${id}`, data);
    }

    removeUser(userId) {
      return this.apiService.delete(`/users/${userId}`);
    }

    getUserById(userId) {
      return this.apiService.get(`/users/${userId}`);
    }
  }
  